import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import pickleballCourtGolden from '@/assets/pickleball-court-golden.jpg';

const PickleballHero = () => {
  const handleScheduleCall = () => {
    window.open("https://calendly.com/kentfrazier/30-minutes", "_blank");
  };

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${pickleballCourtGolden})` }}
      />
      <div className="absolute inset-0 bg-foreground/85" />

      <div className="container-mobile relative z-10 text-center max-w-3xl mx-auto">
        <p className="text-primary font-semibold tracking-[0.15em] uppercase text-sm mb-4 drop-shadow-lg">
          The Paradox of Pickleball
        </p>

        <h1 className="text-background text-4xl sm:text-5xl lg:text-6xl mb-4 drop-shadow-lg" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
          Thriving Through Play
        </h1>

        <p className="text-primary text-xl sm:text-2xl font-display italic mb-6" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
          Play the Game. Master Yourself.
        </p>

        <p className="text-background/90 leading-relaxed mb-10 text-lg max-w-2xl mx-auto drop-shadow-lg" style={{ textShadow: '0 1px 6px rgba(0,0,0,0.5)' }}>
          Develop your <span className="font-medium text-background">mindset</span> and{' '}
          <span className="font-medium text-background">skillset</span> for optimal performance on and off court.
        </p>

        <Button
          onClick={handleScheduleCall}
          className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105"
        >
          Let's Play <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </div>
    </section>
  );
};

export default PickleballHero;
